// extracted by mini-css-extract-plugin
export default {"gift":"style_gift__JG0kg","content":"style_content__ALPlI","scan":"style_scan__DUoSw"};